import { render, staticRenderFns } from "./DataViewSidebarAssurances.vue?vue&type=template&id=b5143752&scoped=true&"
import script from "./DataViewSidebarAssurances.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarAssurances.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarAssurances.vue?vue&type=style&index=0&id=b5143752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5143752",
  null
  
)

export default component.exports